import React, { createContext, useContext, useEffect, useState } from 'react'
import { client } from '../lib/sanityClient'

const LISTING_QUERY = `*[_type == "howToVideo" && active == true] | order(publishedAt desc) {
  _id,
  title,
  "slug": slug.current,
  excerpt,
  thumbnail,
  category,
  difficulty,
  tags,
  durationSeconds,
  presenter,
  publishedAt,
  "hasVideo": defined(videoFile) || defined(youtubeUrl)
}`

const HowToVideoContext = createContext(null)

export function HowToVideoProvider({ children }) {
  const [videos, setVideos] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    let cancelled = false

    client
      .fetch(LISTING_QUERY)
      .then((data) => {
        if (!cancelled) {
          setVideos(data || [])
          setLoading(false)
        }
      })
      .catch((err) => {
        if (!cancelled) {
          console.error('Failed to fetch how-to guides:', err)
          setError(err)
          setLoading(false)
        }
      })

    return () => {
      cancelled = true
    }
  }, [])

  const hasActiveVideos = !loading && videos.length > 0

  return (
    <HowToVideoContext.Provider value={{ videos, loading, error, hasActiveVideos }}>
      {children}
    </HowToVideoContext.Provider>
  )
}

export function useHowToVideos() {
  const ctx = useContext(HowToVideoContext)
  if (!ctx) throw new Error('useHowToVideos must be used within a HowToVideoProvider')
  return ctx
}
